import SidebarMenuList from './SidebarMenuList';

export default SidebarMenuList;
